// Imported from the leaf module, not the "@api" barrel: this file is otherwise
// dependency-free and its test config does not define every alias the barrel pulls in.
import { getServerErrorMessage } from "@api/errors";

export const errorMessageFor = (error) =>
  getServerErrorMessage(error) ||
  error?.response?.data?.title ||
  (error ? "Something went wrong. Please try again." : null);
